import React from 'react';

const FollowUpContext = React.createContext();

export default FollowUpContext;
